var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.98438 16.0001C4.56837 16.0001 0.984375 12.4081 0.984375 8.00012L0.98745 7.77631C1.1061 3.46366 4.64322 0.00012207 8.98438 0.00012207C13.3924 0.00012207 16.9844 3.58412 16.9844 8.00012C16.9844 12.4081 13.3924 16.0001 8.98438 16.0001ZM12.1844 6.4161C11.9444 6.1841 11.5684 6.1841 11.3364 6.4241L8.98435 8.7841L6.63235 6.4241C6.40035 6.1841 6.01635 6.1841 5.78435 6.4161C5.54435 6.6561 5.54435 7.0321 5.78435 7.2641L8.56035 10.0561C8.67235 10.1681 8.82435 10.2321 8.98435 10.2321C9.14435 10.2321 9.29635 10.1681 9.40835 10.0561L12.1844 7.2641C12.3044 7.1521 12.3604 7.0001 12.3604 6.8481C12.3604 6.6881 12.3044 6.5361 12.1844 6.4161Z",
    fill: "#88A5CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown2);
export default __webpack_public_path__ + "static/media/arrow-down2.a55a835cf4e141c0ddb94c92b8d5cf99.svg";
export { ForwardRef as ReactComponent };